import { useState, useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import { useParams } from 'react-router-dom';
import { BsInfo, BsX } from 'react-icons/bs';
import { Helmet } from 'react-helmet';

import styles from './index.module.scss';
import Marquee from '../../components/Marquee';
import InfoPanel from './InfoPanel';
import ImageNav from './ImageNav';
import Products from './Products';
import BLEU from './products/bleu';
import ROSE from './products/rose';
import ROUGE from './products/rouge';
import VERT from './products/vert';
import { PRODUCTS, PRODUCT_LINES } from './constants';

const cx = classNames.bind(styles);

const Detail = () => {
  const { title } = useParams();
  const observeRef = useRef(null);
  const [openInfo, setOpenInfo] = useState(false);
  const [isOverlap, setOverlap] = useState(true);

  useEffect(() => {
    if (observeRef.current) {
      const observer = new IntersectionObserver(
        (entry) => {
          setOverlap(entry[0].isIntersecting);
        },
        { threshold: 0.2 },
      );
      observer.observe(observeRef.current);
    }
  }, [title]);

  const toggleInfo = () => {
    setOpenInfo(!openInfo);
  };

  return (
    <main className={cx('container')}>
      <Helmet>
        <title>르브레 | {title}</title>
        <link rel="canonical" href={`http://www.levraiofficial.com/product/${title}`} />
      </Helmet>
      <div className={cx('wrapper')}>
        <article className={cx(['content', title])}>
          <ImageNav data={PRODUCTS.find((product) => product.title === title)} />
          {title === 'BLEU' && <BLEU />}
          {title === 'VERT' && <VERT />}
          {title === 'ROUGE' && <ROUGE />}
          {title === 'ROSE' && <ROSE />}
        </article>
        <div className={cx(['infoPanel', { open: openInfo, active: isOverlap === false }])}>
          <InfoPanel data={PRODUCT_LINES[title]} />
        </div>
        <button className={cx(['infoButton', title, { open: openInfo }])} type="button" onClick={toggleInfo}>
          {openInfo ? <BsX /> : <BsInfo />}
        </button>
      </div>
      <div ref={observeRef}>
        <Marquee />
        <Products data={PRODUCTS.filter((product) => product.title !== title)} />
      </div>
    </main>
  );
};

export default Detail;
